var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.icon.src)?_c('i',_vm._g({class:['n-icon', _vm.type, 'fa-'+_vm.icon, {'fa-pulse': _vm.pulse}]},_vm.$listeners)):_c('img',{staticClass:"icon-img-n-icon",attrs:{"src":_vm.icon.src,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }